/* eslint-disable max-len */
/* eslint-disable no-constant-condition */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
/* eslint-disable radix */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ethers } from 'ethers';
// import { useMediaQuery } from 'react-responsive';
import keccak256 from 'keccak256';
import { MerkleTree } from 'merkletreejs';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
// import axios from 'axios';
import abi from '../../files/HealingCodes.json';

const IS_PROD = true;
const CONTRACT_ADDRESS = IS_PROD
  ? '0x92927958630fD8Eef91305fb7E1Cac323F779305'
  : '0xE082F93DDa091959b1Ae87E88b5902d59237CFEa';
const ALCHEMY_URL = 'https://eth-mainnet.g.alchemy.com/v2/llIaW4L2LK3CY_eXqIqKUVpnMlpSPr56'; // let serverlessresponse;
// const WEI_PER_ETH = '1000000000000000000';
// const WEI_PER_TOK_EA = '.0888';

const customStyles = {
  content: {
    overflow: 'show',
    width: '270px',
    height: '410px',
    fontFamily: 'Roboto',
    top: '50%',
    left: '50%',
    right: 'auto',
    backgroundColor: 'black',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: '2px solid #E2AE30',
    color: '#fff',
  },
};

const addrs = ['0x02eB75be1E72E988DE64F0088D654D8EA1081E87', '0x0e7F84dE7791B0C0699c9021bAD768ED2ED4Ba57', '0xEEda1A354924A6822FE80074fD625b35cdBD23aC', '0x35E7C849021957F57d8D3e5dAF2d46bfAdfD9C04', '0xd81355B07fBeA40840f114E640ce489BB951A4bB', '0x5f3299c51E55cd781f9E74069055bACd3f086FCb', '0x6140f96d4216ea0C7ac33624EF9ce3e104DC2d56', '0x09D57F361f794D150C04443A7B6e369120DC2bea', '0x349Ade0bb70597BA1802f0F5783D9304375f7f58', '0x62e3E1f39025fdADD7454704C13B7b2AE8C1A8EA', '0x969Cc1615754e16584d5AA464091090563433A08', '0x435fe0a68fEB35DFdbAAbF3845c09f9A482564a2', '0xec9D209252fE238037021e6e6B1aC99cF7f46dF6', '0xFFE59bd3C483a7d099599eC7a2748b6bEaFe485d', '0x20Da700EA03E9fe8bf3409d6F66105184AEfB2FC', '0x0257398931A402978ccec5E33c88227d21A3b949', '0x863d6F04DbC6966e11EE7Cbd953C7f78F3900Cae', '0x7F243Ae56F05AC19c9F4aeE3835356F6CE56ceD4', '0x95E589A8Fdfda604E07428632dCF0267e22c1cfF', '0xb7466a15783dcAdD03CB78e13dc12D25c841a2B9', '0x1c51Aaf0dFeC78763E94c11020ef316ADE1E65A2', '0xF96620D2f93e9F94EEFB39976e02134fe2a6b2F3', '0xFC5eE5E3628d938f0293cD4086be6DDd1E85a4D5', '0xa25dd72698a703dCBb906ccE432CbA0586E04fD0', '0xF6c632C96969D7025695a4c5acAB683695054a1A', '0x8B6f10Ba5fE7358B0bbC49a76E5F17EE0eB984F0', '0xa992332EB15eCc84E53D05830fd3aC5B49e400E9', '0x0161ce5F9f7F45A0784051ab6882Dc244Cf7e57b', '0x18D559B3d7Da802e02E9Fa8A7FCc4ad09584C830', '0xd16CBc00d609a7f0c47E52baf589654e13e41E6a', '0x76B15436cE7A02288E514e0eb0E10075a4410Be6', '0xEB49838236d68A8BF49599ab3CA77ede2B8b639F', '0xe2d3aC725E6FFE2b28a9ED83bedAaf6672f2C801', '0xe9f0Fad94d6d2Bd0A70137f1Fae2287780625a8B', '0x3Ebf5A4fa5DB9001A43906f5150Ce50a79E9786a', '0xebFe65b40A155350FD5F1Af092b7B00Ffc6ECBCD', '0x891eFDA7957736f3ffFc535ef1E294f72164Bf40', '0x97Db0E57b1C315a08cc889Ed405ADB100D7F137d', '0x4D175c43a5939bea202FC53eFeB9d6b7A6cb6708', '0x2fd3516c2533C7E651F7a1Bf0da0F0353c44Ec2F', '0x473154b71B4722986018c800F5c3F6146Baf8a95', '0xB3Cf6DEF6831276378C7f4A6D1411ff9AD22312E', '0xa420498d714370F3BC49C1DCa7547394aCe8CE60', '0x411d2dd9DAE06016D01C71256cA0025A6e111444',
  '0xD86b11C0725042C977ef837430442ce2D607FA7f', '0x4257A066b654F3C3DEE5A2C3F5D65f27321fB0e7', '0x794C4e62Efcc7531f45c24565B70655292CC54E0', '0xdcb3f6584F12b2e0150A3E820fB2BA2f51933B56', '0x5aeCC1cCA4D0926b8D16A7bb89FbE0f974B6c65B', '0x9d8D595355f8887A7203BC22c45f7b86e64DaC3E', '0x453f707dF29334878c5c012Da747705C2c6E8235', '0xb66af334Ca5488cF45903E286ED9F657Cacd50d9', '0xf67FFCd1461b6427B994184b362900B69df1585A', '0x7A6a337137a16D27B1c7CA013Be4194D46090291', '0x4d7fff7979ee3438Fa3483dDAbf7076bb29291BC', '0x69b421C4e3b353F240F5d17e27d514579CD3d019', '0x0061fDf3Bb729Dfa4ceC0808a91DCDcB931A4630', '0xd659B3cede6158E8BF4c493b75809f215CE4e46B', '0xCE0939e8546546511314c2Bd9DbedfDCec74CF8E', '0xD6Fc89004c5Aa526a13407b37a03D700DF0b2EaF', '0xF79395A670e11A58223c7E2480A8ed5aaF2eb558', '0xE9b4a11F3447b908F0680B97982D616AF3066EAd', '0x518b870520476e08Ee523a285e9255B443883885', '0x339858A776bb65f4f4F12D5aB8aA40EB3447cB2e', '0x95D1B24D42F41bCe82A7901B6dE9dEDf73085B55', '0xFF839b277AC4a40E458caFf575DC24e129298Cd1', '0xb9076Ac54D4059661a24Ff1831E8719A98eB8FC7', '0xd9f7FA14dA177ff68bAD47ab30fE933Db75c3e43', '0x4A0962949BeAC41d4f7F81F96d510E0E1465b5Fa', '0x888CB10A3e088455eD76Ec2E9aBEC565437EEc55', '0x06B8AFB6cf1F18DdcD937aB0037CE8cC7DE1F789', '0xb1Af92252166bEA164E2B70Eac8De738d078EDb4', '0x4A54258008aD9AE1836ef9F9B2C535b2997c52ac', '0x4c0a16bd62E1d9132dD9d73025EA36ea99a25CE0', '0x4FC31591586075BE5DE33f223bFfF060283BabD4', '0x1aC30EBb6fE7C1f0D3cB322e2B1480325bC78BdE', '0x28d3Bf5b43B91B3b6B4413c5Cd0482b08d4F1240', '0x1C701A8427fa7a8f8DBBBF4486A516BBab3a4b37', '0x283dFAa16e979C0Fa4944C7eD145204A3cf4d74b', '0x6f5C58a96f32675453D49585dAF03fDfe0d1c784', '0x3BC3a258fc6Dd9F6D3021a47b44706c656Faa6Da', '0xfa639ba57ad35d63688a9bA0FA7D89B79699EA5e', '0xEAb3739D4E716BB07901d72dC94b4139B6968623', '0xe8dbB00B69D67E599B60A205FFa40A4F154f5f4b', '0x22d95BA640e9F505622702443eF4B9D0E7e2cB6f', '0xc44505d1111EC42279AedE122A77CBa17359438d', '0x3e2DbDa5F310aADe1503557b2E7f356eaF161641', '0x6531c91088Fd5Ecb8da2aC3BC518782a0665d774', '0x2ed4da5Adb9085E24883E6eF266e2517c7115f4E', '0x808957caBA3c90Aa39b6ddbDBbb43f901A812818', '0xE98FAffE0ddF04d3ed7569156B4E4C3E7914499C', '0x38cBE3D10D73ad7aB815cb21653Be59F1f0e524e', '0x4Dbdc1d885F5f1C249A96C4AfD9ffEdbc3c82D80', '0xCE3004072Af261bca5BA7f7950DEC47099aAe913', '0xBdb71F484726256031C4079A5ECEd1a628b396AF', '0x066F2f808a2Cbd52F6057d800a4ea11E826C3f45',
  '0xb3D404F430B8868503f18b3b8617bb8703a13B00', '0xFA756A92973B1Bbbee9dF4B2Ea3DaE2E5891d424', '0x6AEEeEC29d374e5e80F09264f3cAbBA4528BfC11', '0xEc1283Da92988Eb4047cD29bF96f4c3b300Cc2Cf', '0x6524E9B964978b86Ad6AA5B11374864926f0cfa5', '0xdDEDbc015647c6a1f1B6D884B4D23eaf8b27cba5', '0x94eB1Ee98D66B742add15F854ce466c00Ba4B98f', '0x67E89603615bCeBD016B5A3fe21A19831A0A5ab0', '0x353f6124e6316cC19f0f0c4335bDFa1B268071B3', '0xCe38C1652b1F6f2bB6F9020F61248E12b386ba5C', '0xb7d310f5B8801d175E3f80AEeCdA5F16Ca93B0B1', '0x70167Fc6467DC25089fb6231e01ce751434a1540', '0x3A847fBEfb433CE75F22dfc2bf18a57058C7eF02', '0x7C384Ee61356Dc5081B0BAb2437f5BdCc40FbcDe', '0x721E8FfE7Ad4aC12f99a54feACa97cfa0F758f46', '0x842969a287805Aef76b3357218dB9c5449e254A0', '0xe7217c26977F054d417e192580Ad963b0178130E', '0x07c0205d9a05c23Ec0bE99C7e012A13f61Cc1a4F', '0x23807719299c9bA3C6d60d4097146259c7A16da3', '0x5e130cB7F8CDCfB5A15018ee5846769703Ec4478', '0xDa469A6C78D12996895721fceBA62E510b38FAf3', '0x37C69eF3b006BE31b98b1a978c86c0F79A3AdADa', '0x43CE665896236342210720a8A50B924d85B755a9', '0x16cefa4581F1CDaB906fA203c7bd1d80b4AA6b86', '0xE158926bE7196c01E6A21d19F6B930006Aeff784', '0x7B1745E3a867ECa2b8D0A3F8Eb454bA0273946A8', '0x683ceC3065994eF0D0d74F31C486Ea755cb1D816', '0xbc26233C04c5065338Cb72ee85869c751Af60f88', '0xe66E9c1c759afDf8F15b93B7A36d85Da0f17A6c9', '0xe17d0ac3F7C498924d4920bf279C01536686e014', '0x58beeeA024936f71F071Ca06a6E0d81c8c5d7A7E', '0xAecf149dD07987310f4bf05356f1C7CE6a068B2d', '0xF32ad03FD696Bfc9568eD1f45e69080b8ae855B7', '0xd8C2cea4B41479fae6b64519E5B0EfAf5fEA4FF5', '0x73d30ba3dc4fFD17C28cc2D75D12e50dF98f29CF', '0xc1ec9A78CD741020EE141dC951C23B1A109c5Db3', '0xC18BE3BC509666673e1eCd8AA3b819edcc3Fa14f', '0x4692619c6580f10AA897e6D1ba725DD58121Ea6b', '0x20fA4Cd36968d01479E06fd2Cb49F23fa34FB0A2', '0x507fCf8607fD2f646B76D78378817D17C506BBB1', '0xD5B38f2A542E760c6cde53CCc229ab65D56F66F3', '0x41895CF5eC3FAf9cf22992Aeaba4F62F743E5B18',
  '0x01DAc828E76BBC98E62EBeAc096A36458a6dD5E7', '0x33D9cd50b4e87fb73564d3db2D45316c1810D0C0', '0xf85D8406ACBaCA3c3e69b2feFaeEb050C427337B', '0xAF9d63B0eD9321bBc8EF20CEA57C56578ec4884D', '0xF76326f04e379EBd47E9bfdd84CC68699492Ce5D', '0x15BC0008e906C2fc4E3D32967960e5fE98AC08e3', '0x7d778dcDF90db6370231612ec10Af72EE829D1d3', '0xaF1dbf0B987fb38f35113D1B7e937E170565Dd7A', '0x53dCd272aD24F95Cd0722A17584b0C03554FaBDC', '0x3cc4245e91436b638F0102E49C6d1BaA17E0AB69', '0x4BCe4CA6828eDeE6E341b14dA3FF0068eB0C7c83', '0x3D88E984b1deC0187DEEad28180Ab53969858081', '0xD5f2f28D57689519bbADe52eF6F47cB5558f9645', '0x06C00EC56C165dA0eF0149bf3eD83385C59b5592', '0x544AEd5dbE2834FAdABA5c9422d3A0B96B61B358', '0xe2491f37aBDed59f0299225536b071329Ef652Ae', '0xd96645BF9B9A0CEB1FC30FdD323C27364A31f9d1', '0x87557296043659De4eaa75aEB33b3464796e07DF', '0x61B04d2b5CB1F1F8505E7b4E1cb3d9E8A0B15BaE', '0xF2B09E208f1f41Ffa7F192eAeF59C24B14B52b78', '0xC1c0e9750fAB87ac871eA40D005063F3750fe143', '0xa15fa02c32a121bCBA905386FFB6517d9ce288D5', '0x936Dd8afE0ca93BE3fadbb4B1c4BF1735e8b57da', '0x5b2AaD701dAB7f5d7dFD82a4cF31E336188e8331',
  '0xa1Fe016Eccc5D9E25096062A4187c83962caB7C2', '0xC3916837AABfc501e2fa32C5729327EaD51Cf83B', '0xC1750e9c31Ac0e3511D0eDd22F84116A057e9e55', '0x9cDed728088265f8C8A95ED956e840Ee577a8B3B', '0x93feB1bd679c7BFc7D39C63091Efc22c2c2E2b79', '0x23aed0301c7Ab043aB5402602Dc4ee33E64b79b8', '0xD81Cf1903fC4D385ba7f289fd7380906933585C6', '0x995E0505603a19EE5C469d2359427BeA68C6e953', '0xb2374D8A4A57eC63cf4fD4ee7C99E54673eb9AcA', '0x4753c60BF8660420Cc3d1806C567cEB5f6524828', '0x80a57C208Fa8082a7687eE420d0eD604f325bdb3', '0x322eCAA66f9713eABAe998b5855FaC29E2668cc2', '0xe3EE81d466eC6Dd7c120A823efA6542fE1a67fF2', '0x38391BB89Db46a51C5f475b55E4433BDDF29dDe5', '0xA319d67b695d5708Aa96C67a1ABA49DCD795A6d2', '0xb64a8b4958b0b6ED34BAC93DE8d927aC7c67a8c1', '0x3a2Ea5595098565e7362e04dA30C5ec29435731F', '0x7c02963b075198706e8F9B4448B78Bfbc44D4890', '0x3f609cd699B906d2baC1817fB9bcbCBc367Fa8D4', '0x74dFBDCBE17B7b6C28067eE5c7CCff0A5c30F039', '0xE04b02FE8C698fEFDb61aCa15D009f45b5e7a61b', '0x50F3d1CDc89FF354a56860026d1680D17bA5f5cd', '0x34756D8400f2426851dc46D6ab38F0Df004CE1E7', '0x7A90A4009632067E6C3e9ccB10b6E0B04a2e148E', '0x7198CF986e2f0752A8fffa82a31589D1d35e6d6A', '0xB777477cA81C88cD38f59640A3AF71d69F6F41ed', '0x5812441A9773337CdFabaf563090B6cD74358337', '0xefC54cADcb1E4B4bFbBEda00395E68ce4dA84a10', '0x32fD4d5229827966715Ec1e04fb51b6b1785c3F5', '0xDCEa9F3CEA4Ed0855389f471FC3F51487EE51bC9', '0x1c0Fe39d119bded89bC587b93c75B6f6CcCCbE2F', '0xa214A13Fb19247D20649dBD45d0195b1a73Ec006', '0x662d78f79a1Cc7c24fdCfCF3e90F87134fC1C8Bb',
  '0xa0FE2486b4a9d860B9b246980A07F790e8fEfd77', '0xDf8579039dB3BbB14Acb2eC8942Dc9573c0b649b', '0xe0dA532aC2fc338eef1EF217d72686d2374f3b06', '0x43E3D72316e92c3568b2b19c324D4521428CDBbF', '0x8E01D001A2a328E8B5b16520196E539cD2C37Cf5', '0x67f3D16A91991cF169920F1E79F78E66708Da328', '0xc65256eC81308a855a85A91Ee56C8E9013C6c9ab', '0xa7a864d0f032adBe5697b13094b9B7c82541AD12', '0xE2EeF3D95B0549FE1a2F28903DaAe24BeF6940b3', '0x95b8c7B99862AC54372D20307905Ca85978Fdf16', '0xC0941Fd0ae89b4081b6519C7Af25867c9c262CB3', '0x948a7eB6012Bf7C813f8B0F92739f02D5479De79', '0x6550fA69EF22e69ACC1E671d8cE68cE88c57EEd7', '0xbBD9F56808e182B41D4464d2aCE4dEaEb1a8663d', '0x72B786Ff9ef6D56A2B2dDDcfFF9bf78f353B145b', '0x9a3dd593F62ba22426a0e709B5865df92c2Dd458', '0x5d6F3d0c92D0564151357B0863E55e9ed4631b8d', '0x6AeFC7893D290c2e1bD7e9475b50A222D818154E', '0x45B6ea1c32CF72466689c80c3e1f85056Befd716', '0x1172e69d868A20e7B2EA2a92DDF724E45ba4C7Ab', '0x28389742AE1C774f9E4B5753af9B6AA6c0f6098c', '0x6e5c309fb6e4f92C4C12a334C5576d2F34dbaa1F', '0x70693AA4cDEC7E1d6173b9a1EE6568AB0A09382A', '0xAc18cD55AeD57c428AA8E1A5e48E9eA519F8521b', '0x954ed8A1A74b3860e3588427bE41cc180596ddA4', '0xdD213f6932a986D30a5d8e063C35796BeF697434', '0x379e038f80a97AbB6825c65f71b3B819a779b4Bb', '0x68BDD031C621B49e537c6b18B21F7da99B2D43a7', '0x2b7516d134C6F7537b473718586e7de88fb0cCbA', '0xBe7444F0f544736fB3296E77bb7c5E5f989b71b5', '0x6b2401039013dD8253562f3C1198ba41Ea5f4B37', '0x6E37d79B4744dd82261cFB7B4cCF77Fe513be06F', '0x3a949dAf5a5d0D77169785B3f5AAE4592a4572e1', '0x4b2A2797FAAb26f2881A979aa87eDd8EA7d7A89b', '0xA7510d23aCEF261A9FCFac4Ac54e4fBCc0eCb95f', '0x120016b6da9b03164B09D945346a847470bb9beE', '0x2d9cBC4ECFBd1B8F66Aa798FD51585AE058dAA8B', '0xFd91c6Cf851B70d59F01Ce375628bfdB16f67580', '0xd7fe3D6A035A8a53396b6B48dB74f644b465FAA4', '0x51fF7B29e2AD9E44E5ce8e355Fb45eEde38Bf635', '0x980e22587FC29D25cf2C82BaA6933Dc0F73C09c4', '0xcA19905e6a19d06125D42E894e31d9E18801005D', '0xBdc065B77B6a22144540C3f16782bA78ea44103d'];

const leafNodes = addrs.map((addr) => keccak256(addr));
const merkleTree = new MerkleTree(leafNodes, keccak256, { sortPairs: true });

const merkleRoot = merkleTree.getRoot();

console.log('Merkle Root:', merkleRoot.toString('hex'));

// console.log(merkleTree.toString());

// const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const mintbutton = (props) => {
  const [count, setCount] = useState(1);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalmessage, setMessage] = useState('');
  const [saleState, setSS] = useState(0);
  const [remaining, setRemaining] = useState(0);
  const [early, setEarly] = useState(false);

  let contract;
  if (props.web3Provider) {
    try {
      contract = new ethers.Contract(
        CONTRACT_ADDRESS,
        abi.abi,
        props.web3Provider.getSigner(),
      );
    } catch (err) {
      console.log(err);
      console.error('Error initializing contract');
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const provider = new ethers.providers.JsonRpcProvider(ALCHEMY_URL);
      const contract1 = new ethers.Contract(CONTRACT_ADDRESS, abi.abi, provider);

      // Substitute these with your actual contract's method calls
      const sale = await contract1.saleState();
      const totalMinted = await contract1.totalSupply();
      console.log(sale.toNumber());
      setSS(sale.toNumber());
      setRemaining(parseInt(totalMinted));
    };

    fetchData();
    const intervalId = setInterval(fetchData, 20 * 1000); // fetch every 20 seconds

    // clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const openModal = async () => {
    if (!props.web3Provider) {
      setMessage(
        'You must connect your wallet to the site in order to mint. Please use the connect button.',
      );
    } else if (saleState === 1) {
      if (addrs.includes(props.address)) {
        console.log(saleState);
        setEarly(true);
        setMessage(
          'Thanks for being an TKPBB by Sabet holder. Because your NFT is holding a healing code, you can mint 1 Healing Code for free.',
        );
      } else {
        console.log(saleState);
        setMessage('You are not on the clearlist');
      }
    } else if (saleState === 2) {
      setEarly(true);
      setMessage(
        'Public sale is live! You may mint up to 5 Healing Codes per transaction.',
      );
    } else {
      setMessage('Minting is not available yet.');
    }
    setIsOpen(true);
  };

  function closeModal() {
    setIsOpen(false);
  }

  const afterOpenModal = async () => {
    // references are now sync'd and can be accessed.
  };

  const mint = async () => {
    // const helperScale = 1000000;
    let estimatedGas;

    // const singlePriceWei = ethers.BigNumber.from(WEI_PER_ETH)
    //   .mul(Math.round(WEI_PER_TOK_EA * helperScale))
    //   .div(helperScale);

    // const priceWei = singlePriceWei.mul(count);
    const baboo = keccak256(props.address);
    const hexProof = merkleTree.getHexProof(baboo);

    try {
      estimatedGas = await contract.estimateGas.mint(count, hexProof);
    } catch (err) {
      console.log(err.message);
      alert(
        'Error minting... Do you have enough funds in your wallet and have you not yet minted?',
      );
      return;
    }
    // console.log(estimatedGas);
    const gasLimit = estimatedGas.add(50000); // Add 50,000 to prevent failures from bad gas limit estimate.
    // eslint-disable-next-line one-var

    try {
      await contract.mint(count, hexProof, { gasLimit });
    } catch (err) {
      alert('There was an issue minting.');
      return;
    }
    setMessage('Thanks for minting!');
  };

  const incrementCount = () => {
    if (saleState === 2 && count < 5) {
      setCount(count + 1);
    }
  };

  const decrementCount = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  return (
    <div>
      <div id="mbc">
        <div id="mintbutton" role="button" tabIndex="0" onClick={openModal}>
          Mint
        </div>
        <div>
          <div id="remaining1">{remaining}/4,850</div>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        onAfterOpen={afterOpenModal}
        style={customStyles}
        ariaHideApp={false}
        overlayClassName="Overlay"
      >
        <div id="modalcontainer">
          <div id="modalclose" onClick={closeModal}>
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </div>
          <div id="modalmessagetext">{modalmessage}</div>
          <div id="mintinput">{count}</div>
          <div className="countbutton" id="plus" onClick={incrementCount}>
            <FontAwesomeIcon icon={['far', 'plus']} size="lg" />
          </div>
          <div className="countbutton" id="minus" onClick={decrementCount}>
            <FontAwesomeIcon icon={['far', 'minus']} size="lg" />
          </div>
          {early ? (
            <div
              role="button"
              id="mintreal"
              tabIndex={-1}
              onClick={mint}
              className="mintbutton"
            >
              Mint: FREE + gas
            </div>
          ) : (
            <div id="fakemint" className="mintbutton">
              Mint: FREE + gas
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  provider: state.web3.provider,
  web3Provider: state.web3.web3Provider,
  address: state.web3.address,
  chainId: state.web3.chainId,
});

export default connect(mapStateToProps, null)(mintbutton);
